import { memo } from "react"

const AttentionIconError = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Attention" clip-path="url(#clip0_4804_16983)">
        <path
          id="Attention_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.7899 2.21228C13.9345 0.669967 11.6826 0.669956 10.8272 2.21228L1.08737 19.7731C0.26701 21.2521 1.35558 23.0555 3.06875 23.0555H22.5485C24.2616 23.0555 25.3501 21.2521 24.5299 19.7731L14.7899 2.21228ZM11.6802 9.73791C11.6802 9.12499 12.1854 8.62811 12.8086 8.62811C13.4318 8.62811 13.9371 9.12499 13.9371 9.73791V15.2869C13.9371 15.8999 13.4318 16.3967 12.8086 16.3967C12.1854 16.3967 11.6802 15.8999 11.6802 15.2869V9.73791ZM13.9371 18.6163C13.9371 19.2293 13.4318 19.7261 12.8086 19.7261C12.1854 19.7261 11.6802 19.2293 11.6802 18.6163C11.6802 18.0034 12.1854 17.5065 12.8086 17.5065C13.4318 17.5065 13.9371 18.0034 13.9371 18.6163Z"
          fill="#ED4040"
        />
      </g>
      <defs>
        <clipPath id="clip0_4804_16983">
          <rect width="24" height="24" fill="white" transform="translate(0.808594 0.055542)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(AttentionIconError)
